<script setup lang="ts">
import UiButton from '@/components/core/UiButton.vue';
import UiModal from '@/components/core/UiModal.vue';
import Events, { AppEvents } from '@/constants/Events';
import Icons from '@/constants/Icons';
import ModalNames from '@/constants/ModalNames';
import AppMessages from '@/models/core/AppMessages';
import { deleteByUid } from '@/services/movement';
import { computed } from 'vue';
import { useVfm } from 'vue-final-modal';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  movementId: string;
  movementUid: string;
}>();

const { t } = useI18n();
const { close } = useVfm();

const title = computed(() => t(`modalNames.${ModalNames.Movement.Delete}`, { movementId: props.movementId }));

async function handleConfirm() {
  const { data } = await deleteByUid(props.movementUid);

  if (data) {
    AppEvents.emit(Events.Movement.Deleted, props.movementUid);
    AppMessages.success(t('movements.deleted', { movementId: props.movementId }));
    close(ModalNames.Movement.Delete);
  }
}
</script>

<template>
  <UiModal :icon="Icons.Core.Delete" :modalId="ModalNames.Movement.Delete" sizeClass="w-lg" :title>
    <div class="ui-bg-primary p-8 text-xl">
      {{ t('movements.confirmDelete', { movementId }) }}
    </div>
    <template #actions>
      <UiButton primary @click="handleConfirm">{{ t('core.confirm') }}</UiButton>
      <UiButton @click="close(ModalNames.Movement.Delete)">{{ t('core.cancel') }}</UiButton>
    </template>
  </UiModal>
</template>
